module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-lineup-kanagawa-4-7594107fb6a465d0b5549b70e743075b.jpg";